import { Transition }               from '@uirouter/core';

import { ApiService }          from '../../app-lite/api/api.service';
import { UserSignUpComponent } from './user.sign-up.component';
import { VerifyUserComponent } from './user.verify.component';

export const UsersStates : Array<any> = [
  {
    component: UserSignUpComponent,
    name     : 'app.sign-up',
    resolve  : [
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) => apiService.get('/system/country_types', null, null, {
          bypass: true
        }),
        token: 'countries'
      }
    ],
    url: '/sign_up'
  },
  {
    component: VerifyUserComponent,
    name     : 'app.verify',
    params   : {
      customerId: {
        squash: true,
        value : null
      },
      subscriptionId: {
        squash: true,
        value : null
      }
    },
    resolve: [
      {
        deps     : [ Transition ],
        resolveFn: ( transitionService : Transition ) => transitionService.params().country_code,
        token    : 'countryCode'
      },
      {
        deps     : [ Transition ],
        resolveFn: ( transitionService : Transition ) => transitionService.params().customerId,
        token    : 'customerId'
      },
      {
        deps     : [ Transition ],
        resolveFn: ( transitionService : Transition ) => transitionService.params().subscriptionId,
        token    : 'subscriptionId'
      },
      {
        deps     : [ Transition ],
        resolveFn: ( transitionService : Transition ) => transitionService.params().unlock_code,
        token    : 'unlockCode'
      },
      {
        deps     : [ Transition ],
        resolveFn: ( transitionService : Transition ) => transitionService.params().email,
        token    : 'username'
      }
    ],
    url: '/login_verify/:customerId/:subscriptionId?country_code&email&unlock_code'
  }
];
